import React from 'react';
import { StarIcon } from 'lucide-react';
export function SponsorReportMockup() {
  const campaignData = {
    campaignDate: 'Jan 15-22, 2025',
    totalImpressions: 12400,
    totalClicks: 892,
    overallCTR: 7.2
  };
  const segmentPerformance = [{
    name: 'Solo Travelers',
    impressions: 3100,
    clicks: 490,
    ctr: 15.8,
    isBest: true
  }, {
    name: 'Sponsor Clickers',
    impressions: 2800,
    clicks: 510,
    ctr: 18.2,
    isBest: false
  }, {
    name: 'Deal Hunters',
    impressions: 4200,
    clicks: 521,
    ctr: 12.4,
    isBest: false
  }];
  return <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 w-full" data-id="element-728">
            {/* Header */}
            <div className="mb-6 pb-4 border-b border-gray-200" data-id="element-729">
                <div className="flex items-center justify-between" data-id="element-730">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-731">
                        Sponsor Performance Report
                    </h3>
                    <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-732">
                        {campaignData.campaignDate}
                    </span>
                </div>
            </div>

            {/* Overall Stats */}
            <div className="grid grid-cols-3 gap-4 mb-6 p-4 bg-gray-50 rounded-lg" data-id="element-733">
                <div data-id="element-734">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-735">Total Impressions</div>
                    <div className="text-2xl font-bold text-gray-900" data-id="element-736">
                        {campaignData.totalImpressions.toLocaleString()}
                    </div>
                </div>
                <div data-id="element-737">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-738">Total Clicks</div>
                    <div className="text-2xl font-bold text-gray-900" data-id="element-739">
                        {campaignData.totalClicks.toLocaleString()}
                    </div>
                </div>
                <div data-id="element-740">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-741">Overall CTR</div>
                    <div className="text-2xl font-bold text-gray-900" data-id="element-742">
                        {campaignData.overallCTR}%
                    </div>
                </div>
            </div>

            {/* Segment Breakdown */}
            <div className="mb-4" data-id="element-743">
                <h4 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-744">
                    Performance by Segment
                </h4>
                <div className="space-y-3" data-id="element-745">
                    {segmentPerformance.map((segment, index) => <div key={index} className={`p-4 rounded-lg border-2 transition-all ${segment.isBest ? 'border-blue-600 bg-blue-600/5' : 'border-gray-200 bg-white'}`} data-id="element-746">
                            <div className="flex items-center justify-between mb-2" data-id="element-747">
                                <div className="flex items-center" data-id="element-748">
                                    <span className="font-semibold text-gray-900" data-id="element-749">
                                        {segment.name}
                                    </span>
                                    {segment.isBest && <div className="ml-2 flex items-center bg-blue-600 text-white text-xs px-2 py-1 rounded-full" data-id="element-750">
                                            <StarIcon className="w-3 h-3 mr-1 fill-current" data-id="element-751" />
                                            Best Performer
                                        </div>}
                                </div>
                                <div className="text-right" data-id="element-752">
                                    <div className="text-xl font-bold text-gray-900" data-id="element-753">
                                        {segment.ctr}%
                                    </div>
                                    <div className="text-xs text-gray-500" data-id="element-754">CTR</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-755">
                                <div data-id="element-756">
                                    <span className="text-gray-500" data-id="element-757">Impressions: </span>
                                    <span className="font-medium text-gray-900" data-id="element-758">
                                        {segment.impressions.toLocaleString()}
                                    </span>
                                </div>
                                <div data-id="element-759">
                                    <span className="text-gray-500" data-id="element-760">Clicks: </span>
                                    <span className="font-medium text-gray-900" data-id="element-761">
                                        {segment.clicks.toLocaleString()}
                                    </span>
                                </div>
                            </div>
                            {segment.isBest && <div className="mt-3 pt-3 border-t border-blue-600/20" data-id="element-762">
                                    <p className="text-xs text-gray-700" data-id="element-763">
                                        This segment drove{' '}
                                        <span className="font-semibold" data-id="element-764">
                                            2.2x higher engagement
                                        </span>{' '}
                                        than your overall list average
                                    </p>
                                </div>}
                        </div>)}
                </div>
            </div>

            {/* Footer Insight */}
            <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-765">
                <div className="bg-blue-50 rounded-lg p-4" data-id="element-766">
                    <p className="text-sm text-gray-700" data-id="element-767">
                        <span className="font-semibold" data-id="element-768">Key Insight:</span> Your "Solo
                        Travelers" and "Sponsor Clickers" segments significantly
                        outperformed the overall list. Consider offering premium placement
                        rates for these high-value segments.
                    </p>
                </div>
            </div>
        </div>;
}